import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddToOrganisationImportRequestMutationVariables = Types.Exact<{
  organisationUuid: Types.Scalars['ID']['input'];
  toUsername: Types.Scalars['String']['input'];
}>;


export type AddToOrganisationImportRequestMutation = { __typename?: 'Mutation', sendAddToOrganisationRequest: boolean };


export const AddToOrganisationImportRequestDocument = gql`
    mutation AddToOrganisationImportRequest($organisationUuid: ID!, $toUsername: String!) {
  sendAddToOrganisationRequest(
    organisationUuid: $organisationUuid
    toUsername: $toUsername
  )
}
    `;
export type AddToOrganisationImportRequestMutationFn = Apollo.MutationFunction<AddToOrganisationImportRequestMutation, AddToOrganisationImportRequestMutationVariables>;

/**
 * __useAddToOrganisationImportRequestMutation__
 *
 * To run a mutation, you first call `useAddToOrganisationImportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToOrganisationImportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToOrganisationImportRequestMutation, { data, loading, error }] = useAddToOrganisationImportRequestMutation({
 *   variables: {
 *      organisationUuid: // value for 'organisationUuid'
 *      toUsername: // value for 'toUsername'
 *   },
 * });
 */
export function useAddToOrganisationImportRequestMutation(baseOptions?: Apollo.MutationHookOptions<AddToOrganisationImportRequestMutation, AddToOrganisationImportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToOrganisationImportRequestMutation, AddToOrganisationImportRequestMutationVariables>(AddToOrganisationImportRequestDocument, options);
      }
export type AddToOrganisationImportRequestMutationHookResult = ReturnType<typeof useAddToOrganisationImportRequestMutation>;
export type AddToOrganisationImportRequestMutationResult = Apollo.MutationResult<AddToOrganisationImportRequestMutation>;
export type AddToOrganisationImportRequestMutationOptions = Apollo.BaseMutationOptions<AddToOrganisationImportRequestMutation, AddToOrganisationImportRequestMutationVariables>;